import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../App";

function Sidebar({ isAdmin }) {
	const { logout } = useAuth();

	return (
		<aside className='sidebar'>
			<div className='sidebar-header'>
				<div className='sidebar-logo'>Lab Scheduler</div>
			</div>

			<nav className='sidebar-nav'>
				{isAdmin ? (
					<>
						<div className='nav-section'>Dashboard</div>
						<NavLink
							to='/'
							className={({ isActive }) =>
								`nav-item ${isActive ? "active" : ""}`
							}
						>
							<svg
								width='20'
								height='20'
								fill='currentColor'
								viewBox='0 0 20 20'
							>
								<path d='M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z' />
							</svg>
							Dashboard
						</NavLink>

						<div className='nav-section'>Management</div>
						<NavLink
							to='/employees'
							className={({ isActive }) =>
								`nav-item ${isActive ? "active" : ""}`
							}
						>
							<svg
								width='20'
								height='20'
								fill='currentColor'
								viewBox='0 0 20 20'
							>
								<path d='M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z' />
							</svg>
							Employees
						</NavLink>
						<NavLink
							to='/departments'
							className={({ isActive }) =>
								`nav-item ${isActive ? "active" : ""}`
							}
						>
							<svg
								width='20'
								height='20'
								fill='currentColor'
								viewBox='0 0 20 20'
							>
								<path
									fillRule='evenodd'
									d='M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z'
									clipRule='evenodd'
								/>
							</svg>
							Departments
						</NavLink>

						<div className='nav-section'>Scheduling</div>
						<NavLink
							to='/schedule'
							className={({ isActive }) =>
								`nav-item ${isActive ? "active" : ""}`
							}
						>
							<svg
								width='20'
								height='20'
								fill='currentColor'
								viewBox='0 0 20 20'
							>
								<path
									fillRule='evenodd'
									d='M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z'
									clipRule='evenodd'
								/>
							</svg>
							Schedule
						</NavLink>
						<NavLink
							to='/assignments'
							className={({ isActive }) =>
								`nav-item ${isActive ? "active" : ""}`
							}
						>
							<svg
								width='20'
								height='20'
								fill='currentColor'
								viewBox='0 0 20 20'
							>
								<path d='M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z' />
							</svg>
							Assignments
						</NavLink>
						<NavLink
							to='/overtime'
							className={({ isActive }) =>
								`nav-item ${isActive ? "active" : ""}`
							}
						>
							<svg
								width='20'
								height='20'
								fill='currentColor'
								viewBox='0 0 20 20'
							>
								<path
									fillRule='evenodd'
									d='M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z'
									clipRule='evenodd'
								/>
							</svg>
							OT Candidates
						</NavLink>
						<NavLink
							to='/leave-management'
							className={({ isActive }) =>
								`nav-item ${isActive ? "active" : ""}`
							}
						>
							<svg
								width='20'
								height='20'
								fill='currentColor'
								viewBox='0 0 20 20'
							>
								<path
									fillRule='evenodd'
									d='M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm4 9a1 1 0 100-2 1 1 0 000 2zm3-1a1 1 0 11-2 0 1 1 0 012 0zm1 3a1 1 0 100-2 1 1 0 000 2zm-3 1a1 1 0 11-2 0 1 1 0 012 0zm-5-1a1 1 0 100-2 1 1 0 000 2z'
									clipRule='evenodd'
								/>
							</svg>
							Leave Management
						</NavLink>
					</>
				) : (
					<>
						<div className='nav-section'>My Portal</div>
						<NavLink
							to='/'
							className={({ isActive }) =>
								`nav-item ${isActive ? "active" : ""}`
							}
						>
							<svg
								width='20'
								height='20'
								fill='currentColor'
								viewBox='0 0 20 20'
							>
								<path d='M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z' />
							</svg>
							Home
						</NavLink>
						<NavLink
							to='/my-schedule'
							className={({ isActive }) =>
								`nav-item ${isActive ? "active" : ""}`
							}
						>
							<svg
								width='20'
								height='20'
								fill='currentColor'
								viewBox='0 0 20 20'
							>
								<path
									fillRule='evenodd'
									d='M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z'
									clipRule='evenodd'
								/>
							</svg>
							My Schedule
						</NavLink>
					</>
				)}

				<div style={{ marginTop: "auto", paddingTop: "2rem" }}>
					<button
						onClick={logout}
						className='nav-item'
						style={{
							width: "100%",
							border: "none",
							background: "transparent",
							cursor: "pointer",
							textAlign: "left",
						}}
					>
						<svg
							width='20'
							height='20'
							fill='currentColor'
							viewBox='0 0 20 20'
						>
							<path
								fillRule='evenodd'
								d='M3 3a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1H3zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z'
								clipRule='evenodd'
							/>
						</svg>
						Logout
					</button>
				</div>
			</nav>
		</aside>
	);
}

export default Sidebar;
